(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sleek-menu-drawer"] && !Shopify.designMode) return;
  try {
    const ANIM_DURATION = 300;
  const ANIM_EASING = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';

  class SleekMenuDrawer extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('sleek-menu-drawer--cascade')) {
        this.querySelectorAll('.sleek-menu-drawer__details > summary').forEach((summary) => {
          summary.addEventListener('click', this.#onSummaryClick);
        });
      }
      this.querySelectorAll('.sleek-menu-drawer__mega-l2 > summary').forEach((summary) => {
        summary.addEventListener('click', this.#onMegaL2Click);
      });
      this.querySelectorAll('.sleek-menu-drawer__details > summary .sleek-menu-drawer__item-text').forEach((text) => {
        text.addEventListener('click', this.#onTextClick);
      });
    }

    disconnectedCallback() {
      this.querySelectorAll('.sleek-menu-drawer__details > summary').forEach((summary) => {
        summary.removeEventListener('click', this.#onSummaryClick);
      });
      this.querySelectorAll('.sleek-menu-drawer__mega-l2 > summary').forEach((summary) => {
        summary.removeEventListener('click', this.#onMegaL2Click);
      });
      this.querySelectorAll('.sleek-menu-drawer__details > summary .sleek-menu-drawer__item-text').forEach((text) => {
        text.removeEventListener('click', this.#onTextClick);
      });
    }

    #onTextClick = (event) => {
      const summary = event.currentTarget.closest('summary');
      const url = summary?.dataset.url;
      if (url) {
        event.stopPropagation();
        window.location.href = url;
      }
    };

    #onSummaryClick = (event) => {
      event.preventDefault();
      const summary = event.currentTarget;
      const details = summary.closest('details');
      const submenu = details.querySelector(':scope > .menu-drawer__submenu');
      if (!submenu) return;
      this.#animateHeight(
        submenu,
        details.classList.contains('menu-open'),
        () => {
          if (!details.open) details.open = true;
          details.classList.add('menu-open');
          summary.setAttribute('aria-expanded', 'true');
        },
        () => {
          details.classList.remove('menu-open');
          summary.setAttribute('aria-expanded', 'false');
        }
      );
    };

    #onMegaL2Click = (event) => {
      event.preventDefault();
      const details = event.currentTarget.closest('.sleek-menu-drawer__mega-l2');
      const content = details.querySelector(':scope > .sleek-menu-drawer__mega-l2-content');
      if (!content) return;
      this.#animateHeight(
        content,
        details.open,
        () => { details.open = true; },
        () => { details.open = false; }
      );
    };

    #animateHeight(el, isOpen, openFn, closeFn) {
      el.getAnimations().forEach((a) => a.cancel());
      if (isOpen) {
        const h = el.getBoundingClientRect().height;
        closeFn();
        el.animate([{ height: h + 'px' }, { height: '0px' }], {
          duration: ANIM_DURATION, easing: ANIM_EASING,
        }).onfinish = () => { el.style.height = '0px'; };
      } else {
        openFn();
        el.getBoundingClientRect(); // force reflow
        el.style.height = '0px';
        el.animate([{ height: '0px' }, { height: el.scrollHeight + 'px' }], {
          duration: ANIM_DURATION, easing: ANIM_EASING,
        }).onfinish = () => { el.style.height = 'auto'; };
      }
    }
  }

  if (!customElements.get('sleek-menu-drawer')) {
    customElements.define('sleek-menu-drawer', SleekMenuDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
